import * as React from "react"
import { graphql } from "gatsby"
import * as styles from "./HtmlSnippet.css"

export type HtmlSnippetProps = {
  html: string
  displayFullWidth?: boolean
}

export default function HtmlSnippet(props: HtmlSnippetProps) {
  
  const className = props?.displayFullWidth ? `${styles.fullWidth}` : styles.htmlSnippet;

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: props.html,
      }}
    />
  )
}

export const query = graphql`
  fragment HtmlSnippetContent on HtmlSnippet {
    desktopRight
    html
    displayFullWidth
  }
`